import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import mobile from './mobile/mobile.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes, mobile];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    if (to.name === 'profile_ai_connections') {
      sessionStorage.setItem('mcp_authorization_return_to', to.fullPath);
    }
    window.location.assign('/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  const mcpReturnTo = sessionStorage.getItem('mcp_authorization_return_to');
  if (mcpReturnTo) {
    sessionStorage.removeItem('mcp_authorization_return_to');
    if (
      mcpReturnTo.startsWith('/user/ai-connections?') &&
      to.fullPath !== mcpReturnTo
    ) {
      return next(mcpReturnTo);
    }
  }

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, from, next) => {
    const mobileRouteName = `mobile_${to.name}`;
    if (
      from.meta.mobile &&
      !to.meta.mobile &&
      router.hasRoute(mobileRouteName)
    ) {
      next({
        name: mobileRouteName,
        params: to.params,
        query: to.query,
        hash: to.hash,
      });
      return;
    }

    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
